import {
  SET_LOADING_PAGE,
  SET_DOCUMENTOS_SOLICITADOS,
  SET_TIPOS_DOCUMENTO_SOLICITADOS,
  SET_ACCEPT_IMAGE
} from './types';

const initialState = {
  loadingPage: false,
  documentosSolicitados: null,
  tiposDocumentoSolicitados: null,
}


export default function uploadDocumentosReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACCEPT_IMAGE:
      return {
        ...state,
        acceptImage: action.payload
      }
    case SET_TIPOS_DOCUMENTO_SOLICITADOS:
      return {
        ...state,
        tiposDocumentoSolicitados: action.payload
      }
    case SET_DOCUMENTOS_SOLICITADOS:
      return {
        ...state,
        documentosSolicitados: action.payload
      }
    case SET_LOADING_PAGE:
      return {
        ...state,
        loadingPage: action.payload
      }
    default:
      return state
  }
}